import React from "react";
import { Share2 } from "lucide-react";
import { cn } from "@/components/ui/lib/utils";
import { Switch } from "@/components/ui/switch";

interface SharedWithMeToggleButtonProps {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
}

const SharedWithMeToggleButton: React.FC<SharedWithMeToggleButtonProps> = ({
  value,
  onChange,
  className,
}) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="flex items-center space-x-2">
        <Switch
          checked={value}
          id="shared-with-me-only"
          onCheckedChange={onChange}
        />
        <label
          className="flex items-center gap-2 cursor-pointer text-sm font-medium text-black dark:text-gray-300"
          htmlFor="shared-with-me-only"
        >
          <Share2
            className={cn(
              "h-4 w-4",
              value ? "text-blue-500" : "text-black",
            )}
          />
          Shared with me
        </label>
      </div>
    </div>
  );
};

export default SharedWithMeToggleButton;
